import { c as _c } from "react/compiler-runtime";
import { Checkbox, DangerButton, FieldErrorAndDescription, FormInput, Modal, ModalSizeEnum, PrimaryButton, Tooltip } from '@systemeio/ui';
import { eventLocationLocoKeys } from 'modules/calendar/constants/calendar-loco';
import { LocationButton, LocationTypeIcon } from 'modules/calendar/events/components/location-type-fields';
import { EventLocationTypeEnum, locationFields } from 'modules/calendar/events/constants';
import { useCheckZoomIntegration } from 'modules/calendar/events/hooks/use-check-zoom-integration';
import { EventCreateFormInterface, EventEditFormInterface, EventLocationInterface } from 'modules/calendar/events/types/event-interface';
import { filterLocationBasedOnTempState, hasMeetingLink } from 'modules/calendar/events/utils/online-meeting-utils';
import { useCalendars } from 'modules/profile/integrations/google/hooks/use-calendars';
import React, { useState } from 'react';
import { UseFormSetValue } from 'react-hook-form';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { isValidUrl } from 'shared/utils/is-valid-url';
interface LocationOnlineMeetingModal {
  locations: EventLocationInterface[];
  setValue: UseFormSetValue<EventCreateFormInterface | EventEditFormInterface>;
  error?: string;
}
export const LocationOnlineMeetingModal = t0 => {
  const $ = _c(110);
  const {
    locations,
    setValue,
    error
  } = t0;
  const {
    t
  } = useLocoTranslation();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      types: []
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [tempState, setTempState] = useState(t1);
  const [opened, setOpened] = useState(false);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      meetingLink: ""
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [errors, setErrors] = useState(t2);
  const {
    isZoomIntegrated,
    isLoading: isZoomIntegratedLoading
  } = useCheckZoomIntegration();
  const {
    hasGoogleCalendars,
    isLoading: isGoogleCalendarsLoading
  } = useCalendars();
  const isLoading = isGoogleCalendarsLoading || isZoomIntegratedLoading;
  let t3;
  if ($[2] !== locations) {
    t3 = () => {
      const onlineMeetingLocations = locations.filter(_temp);
      const types = onlineMeetingLocations.map(_temp2);
      const externalLinkLocation = onlineMeetingLocations.find(_temp3);
      setTempState({
        types,
        meetingLink: externalLinkLocation?.meetingLink || ""
      });
    };
    $[2] = locations;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const initializeTempState = t3;
  let t4;
  if ($[4] !== locations || $[5] !== setValue) {
    t4 = () => {
      setValue("locations", filterLocationBasedOnTempState(locations));
      setOpened(false);
    };
    $[4] = locations;
    $[5] = setValue;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const deleteLocation = t4;
  let t5;
  if ($[7] !== locations || $[8] !== setValue || $[9] !== t || $[10] !== tempState.meetingLink || $[11] !== tempState.types) {
    t5 = () => {
      if (tempState.types.length === 0) {
        setErrors(prev => ({
          ...prev,
          meetingLink: t("dashboard.validation.empty_error.title")
        }));
        return;
      }
      if (tempState.types.includes(EventLocationTypeEnum.ExternalLink) && !tempState.meetingLink) {
        setErrors(prev_0 => ({
          ...prev_0,
          meetingLink: t("dashboard.validation.empty_error.title")
        }));
        return;
      }
      if (tempState.meetingLink && !isValidUrl(tempState.meetingLink)) {
        setErrors(prev_1 => ({
          ...prev_1,
          meetingLink: t("dashboard.calendar.meeting_link_validation.title")
        }));
        return;
      }
      const newLocations = tempState.types.map(locationType => ({
        ...locationFields[locationType],
        locationType,
        ...(locationType === EventLocationTypeEnum.ExternalLink && {
          meetingLink: tempState.meetingLink
        })
      }));
      setValue("locations", [...filterLocationBasedOnTempState(locations), ...newLocations]);
      setOpened(false);
    };
    $[7] = locations;
    $[8] = setValue;
    $[9] = t;
    $[10] = tempState.meetingLink;
    $[11] = tempState.types;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const onSubmit = t5;
  let t6;
  if ($[13] !== initializeTempState) {
    t6 = () => {
      initializeTempState();
      setOpened(true);
    };
    $[13] = initializeTempState;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== locations) {
    t7 = locations.some(_temp4);
    $[15] = locations;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <LocationTypeIcon locationType={EventLocationTypeEnum.ExternalLink} />;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t) {
    t9 = t(eventLocationLocoKeys[EventLocationTypeEnum.ExternalLink]);
    $[18] = t;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t9) {
    t10 = <span className="flex flex-col items-center justify-center gap-3 ">{t8}{t9}</span>;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== isLoading || $[23] !== t10 || $[24] !== t6 || $[25] !== t7) {
    t11 = <LocationButton locationType={EventLocationTypeEnum.ExternalLink} openLocationModal={t6} isFetching={isLoading} isSelected={t7}>{t10}</LocationButton>;
    $[22] = isLoading;
    $[23] = t10;
    $[24] = t6;
    $[25] = t7;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = () => setOpened(false);
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t) {
    t13 = t(eventLocationLocoKeys[EventLocationTypeEnum.ExternalLink]);
    $[28] = t;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = () => setTempState({
      types: []
    });
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] !== t) {
    t15 = t("dashboard.calendar.event_inactive_zoom_location_error");
    $[31] = t;
    $[32] = t15;
  } else {
    t15 = $[32];
  }
  let t16;
  if ($[33] !== t) {
    t16 = t("dashboard.calendar.event_location_type_zoom");
    $[33] = t;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== tempState.types) {
    t17 = tempState.types.includes(EventLocationTypeEnum.Zoom);
    $[35] = tempState.types;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  const t18 = !isZoomIntegrated;
  let t19;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = () => setTempState(_temp6);
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== isZoomIntegratedLoading || $[39] !== t16 || $[40] !== t17 || $[41] !== t18) {
    t20 = <Checkbox key={`linkType-${EventLocationTypeEnum.Zoom}`} label={t16} value={t17} disabled={t18} isFetching={isZoomIntegratedLoading} onChange={t19} />;
    $[38] = isZoomIntegratedLoading;
    $[39] = t16;
    $[40] = t17;
    $[41] = t18;
    $[42] = t20;
  } else {
    t20 = $[42];
  }
  let t21;
  if ($[43] !== isZoomIntegrated || $[44] !== t15 || $[45] !== t20) {
    t21 = <Tooltip label={t15} mode="hover" disabled={isZoomIntegrated}>{t20}</Tooltip>;
    $[43] = isZoomIntegrated;
    $[44] = t15;
    $[45] = t20;
    $[46] = t21;
  } else {
    t21 = $[46];
  }
  let t22;
  if ($[47] !== t) {
    t22 = t("dashboard.calendar.event_inactive_google_meet_location_error");
    $[47] = t;
    $[48] = t22;
  } else {
    t22 = $[48];
  }
  let t23;
  if ($[49] !== t) {
    t23 = t("dashboard.calendar.event_location.google_meet");
    $[49] = t;
    $[50] = t23;
  } else {
    t23 = $[50];
  }
  let t24;
  if ($[51] !== tempState.types) {
    t24 = tempState.types.includes(EventLocationTypeEnum.GoogleMeet);
    $[51] = tempState.types;
    $[52] = t24;
  } else {
    t24 = $[52];
  }
  const t25 = !hasGoogleCalendars;
  let t26;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = () => setTempState(_temp8);
    $[53] = t26;
  } else {
    t26 = $[53];
  }
  let t27;
  if ($[54] !== isGoogleCalendarsLoading || $[55] !== t23 || $[56] !== t24 || $[57] !== t25) {
    t27 = <Checkbox key={`linkType-${EventLocationTypeEnum.GoogleMeet}`} label={t23} value={t24} disabled={t25} isFetching={isGoogleCalendarsLoading} onChange={t26} />;
    $[54] = isGoogleCalendarsLoading;
    $[55] = t23;
    $[56] = t24;
    $[57] = t25;
    $[58] = t27;
  } else {
    t27 = $[58];
  }
  let t28;
  if ($[59] !== hasGoogleCalendars || $[60] !== t22 || $[61] !== t27) {
    t28 = <Tooltip label={t22} mode="hover" disabled={hasGoogleCalendars}>{t27}</Tooltip>;
    $[59] = hasGoogleCalendars;
    $[60] = t22;
    $[61] = t27;
    $[62] = t28;
  } else {
    t28 = $[62];
  }
  let t29;
  if ($[63] !== t) {
    t29 = t("dashboard.calendar.event_location_type_external_link");
    $[63] = t;
    $[64] = t29;
  } else {
    t29 = $[64];
  }
  let t30;
  if ($[65] !== tempState.types) {
    t30 = tempState.types.includes(EventLocationTypeEnum.ExternalLink);
    $[65] = tempState.types;
    $[66] = t30;
  } else {
    t30 = $[66];
  }
  let t31;
  if ($[67] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = () => setTempState(_temp10);
    $[67] = t31;
  } else {
    t31 = $[67];
  }
  let t32;
  if ($[68] !== t29 || $[69] !== t30) {
    t32 = <Checkbox key={`linkType-${EventLocationTypeEnum.ExternalLink}`} label={t29} value={t30} onChange={t31} />;
    $[68] = t29;
    $[69] = t30;
    $[70] = t32;
  } else {
    t32 = $[70];
  }
  let t33;
  if ($[71] !== error) {
    t33 = <FieldErrorAndDescription className="mt-2" error={error} />;
    $[71] = error;
    $[72] = t33;
  } else {
    t33 = $[72];
  }
  let t34;
  if ($[73] !== errors || $[74] !== t || $[75] !== tempState.meetingLink || $[76] !== tempState.types) {
    t34 = tempState.types.includes(EventLocationTypeEnum.ExternalLink) && <FormInput value={tempState.meetingLink || ""} onChange={e => {
      if (errors.meetingLink) {
        setErrors(_temp11);
      }
      setTempState(prev_6 => ({
        ...prev_6,
        meetingLink: e.target.value
      }));
    }} label={t("dashboard.calendar.event_location_meeting_link")} required={true} error={errors.meetingLink} />;
    $[73] = errors;
    $[74] = t;
    $[75] = tempState.meetingLink;
    $[76] = tempState.types;
    $[77] = t34;
  } else {
    t34 = $[77];
  }
  let t35;
  if ($[78] !== t21 || $[79] !== t28 || $[80] !== t32 || $[81] !== t33 || $[82] !== t34) {
    t35 = <div className="flex flex-col gap-5">{t21}{t28}{t32}{t33}{t34}</div>;
    $[78] = t21;
    $[79] = t28;
    $[80] = t32;
    $[81] = t33;
    $[82] = t34;
    $[83] = t35;
  } else {
    t35 = $[83];
  }
  let t36;
  if ($[84] !== deleteLocation) {
    t36 = e_0 => {
      e_0.preventDefault();
      deleteLocation();
    };
    $[84] = deleteLocation;
    $[85] = t36;
  } else {
    t36 = $[85];
  }
  let t37;
  if ($[86] !== t) {
    t37 = t("global.delete");
    $[86] = t;
    $[87] = t37;
  } else {
    t37 = $[87];
  }
  let t38;
  if ($[88] !== t36 || $[89] !== t37) {
    t38 = <DangerButton className="w-full" width="large" onClick={t36}>{t37}</DangerButton>;
    $[88] = t36;
    $[89] = t37;
    $[90] = t38;
  } else {
    t38 = $[90];
  }
  let t39;
  if ($[91] !== onSubmit) {
    t39 = e_1 => {
      e_1.preventDefault();
      onSubmit();
    };
    $[91] = onSubmit;
    $[92] = t39;
  } else {
    t39 = $[92];
  }
  let t40;
  if ($[93] !== t) {
    t40 = t("global.save");
    $[93] = t;
    $[94] = t40;
  } else {
    t40 = $[94];
  }
  let t41;
  if ($[95] !== t39 || $[96] !== t40) {
    t41 = <PrimaryButton className="w-full" width="large" onClick={t39}>{t40}</PrimaryButton>;
    $[95] = t39;
    $[96] = t40;
    $[97] = t41;
  } else {
    t41 = $[97];
  }
  let t42;
  if ($[98] !== t38 || $[99] !== t41) {
    t42 = <div className="mt-6 flex gap-4 lg:mt-10">{t38}{t41}</div>;
    $[98] = t38;
    $[99] = t41;
    $[100] = t42;
  } else {
    t42 = $[100];
  }
  let t43;
  if ($[101] !== isLoading || $[102] !== opened || $[103] !== t13 || $[104] !== t35 || $[105] !== t42) {
    t43 = <Modal opened={opened} onClose={t12} title={t13} size={ModalSizeEnum.small} isFetching={isLoading} afterLeave={t14}>{t35}{t42}</Modal>;
    $[101] = isLoading;
    $[102] = opened;
    $[103] = t13;
    $[104] = t35;
    $[105] = t42;
    $[106] = t43;
  } else {
    t43 = $[106];
  }
  let t44;
  if ($[107] !== t11 || $[108] !== t43) {
    t44 = <>{t11}{t43}</>;
    $[107] = t11;
    $[108] = t43;
    $[109] = t44;
  } else {
    t44 = $[109];
  }
  return t44;
};
function _temp(loc) {
  return hasMeetingLink(loc.locationType);
}
function _temp2(loc_0) {
  return loc_0.locationType;
}
function _temp3(loc_1) {
  return loc_1.locationType === EventLocationTypeEnum.ExternalLink;
}
function _temp4(t0) {
  const {
    locationType: locationType_0
  } = t0;
  return hasMeetingLink(locationType_0);
}
function _temp5(id) {
  return id !== EventLocationTypeEnum.Zoom;
}
function _temp6(prev_2) {
  return {
    ...prev_2,
    types: prev_2.types.includes(EventLocationTypeEnum.Zoom) ? prev_2.types.filter(_temp5) : [...prev_2.types, EventLocationTypeEnum.Zoom]
  };
}
function _temp7(id_0) {
  return id_0 !== EventLocationTypeEnum.GoogleMeet;
}
function _temp8(prev_3) {
  return {
    ...prev_3,
    types: prev_3.types.includes(EventLocationTypeEnum.GoogleMeet) ? prev_3.types.filter(_temp7) : [...prev_3.types, EventLocationTypeEnum.GoogleMeet]
  };
}
function _temp9(id_1) {
  return id_1 !== EventLocationTypeEnum.ExternalLink;
}
function _temp10(prev_4) {
  return {
    ...prev_4,
    types: prev_4.types.includes(EventLocationTypeEnum.ExternalLink) ? prev_4.types.filter(_temp9) : [...prev_4.types, EventLocationTypeEnum.ExternalLink]
  };
}
function _temp11(prev_5) {
  return {
    ...prev_5,
    meetingLink: ""
  };
}